module.exports = __webpack_public_path__ + "static/media/pizzaSalami.7f45b205.jpg";